// @ts-strict-ignore
const monthsAbbreviation = {
  nl: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
  en: ['jan', 'feb', 'mar', 'apr', 'may', 'june', 'july', 'aug', 'sep', 'oct', 'nov', 'dec'],
  de: ['jan', 'feb', 'marz', 'apr', 'mai', 'juni', 'juli', 'aug', 'sep', 'okt', 'nov', 'dez'],
}

export function getFormattedDate(date: Date, lang: string): string {
  const dateObject = new Date(date)
  const formatted =
    dateObject.getDate() +
    ' ' +
    monthsAbbreviation[lang][dateObject.getMonth()] +
    ' ' +
    dateObject.getFullYear()
  return formatted
}
